import styled from '@emotion/styled';
import React, { FC, useRef } from 'react';
import { createPortal } from 'react-dom';
import TrophyIcon from '~Assets/icons/trophy.svg';
import Icon from '~ComponentsImproved/Icon';
import Heading from '~ComponentsImproved/Typography/Heading';
import { handyBreakpoint } from '~Styles/breakpoints';

const Wrapper = styled.div`
  position: fixed;
  top: 8px;
  left: 50%;
  transform: translateX(-50%);
  background-color: #ffd479;
  color: yellow;
  padding: 8px 16px;
  text-align: center;
  display: flex;
  align-items: center;
  gap: 8px;
  border-radius: 4px;
  animation: fade-in 0.5s ease-in-out;
  box-sizing: border-box;
  z-index: 1;
  box-shadow: 0 0 20px rgb(0 0 0 / 25%);

  ${handyBreakpoint} {
    max-width: calc(100% - 150px);
  }
`;

const Trophy = styled(Icon)`
  flex-shrink: 0;
`;

const Text = styled(Heading)`
  font-size: 14px;
  color: var(--colorBlueGray1300);

  ${handyBreakpoint} {
    font-size: 12px;
  }
`;

interface Props {
  message: string;
}

const Toast: FC<Props> = ({ message }) => {
  const ref = useRef<HTMLDivElement>(null);

  const removeOnClick = () => {
    if (ref?.current) {
      ref?.current?.remove();
    }
  };

  return createPortal(
    <Wrapper ref={ref} onTouchStart={removeOnClick}>
      <Text level={5}>{message}</Text>
      <Trophy src={TrophyIcon} color="#b18b00" />
    </Wrapper>,
    document.body,
  );
};

export default Toast;
